import React, { useMemo } from 'react';
import { Popover } from 'antd';
import './guidePopover.scss';
const ImgBubbleGuide = props => {
    const { placement = 'bottomLeft', children, content, visible, type, showArrow = true, arrowDistance, getPopupContainer } = props;
    const overlayClassName = useMemo(() => {
        let res = `guideBox guide${placement}`;
        if (type === '1') {
            res = res + ' maskGuide';
        }
        else if (type === '2') {
            res = res + ' imgGuide';
        }
        else if (type === '3') {
            res = res + ' tipGuide';
        }
        if (!showArrow) {
            res = res + ' hiddenArrow';
        }
        if (arrowDistance) {
            if (['top', 'bottom', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight'].includes(placement)) {
                res = res + ` arrowLeftDis-${arrowDistance}`;
            }
            else {
                res = res + ` arrowTopDis-${arrowDistance}`;
            }
        }
        return res;
    }, [placement, type, showArrow, arrowDistance]);
    return (React.createElement(Popover, { content: typeof content === 'string' ? content : () => content, placement: placement, visible: visible, autoAdjustOverflow: false, overlayClassName: overlayClassName, destroyTooltipOnHide: false, getPopupContainer: getPopupContainer ? getPopupContainer : trigger => trigger.parentElement || document.body }, children));
};
export default ImgBubbleGuide;
